import './AudioTemplate.scss';
import { IconArrowMedium, IconSocialBunnynet, IconSocialAmazon } from '../icons/svgs';
import AudioPreview from '../preview/AudioPreview';
import NextAction from '../actions/NextAction';
class AudioTemplate {
    structures() {
        return {
            title: {
                label: 'Title',
                type: 'text',
                placeholder: 'Create a cool title',
            },
            description: {
                label: 'Description',
                type: 'tinymce',
                placeholder: 'Description max 600 characters',
                rules: {
                    maxChar: 600, // 320 characters
                }
            },
            platform: {
                type: 'select',
                label: 'Select Platform',
                placeholder: 'Choose Platform', // version MVP: youtube & Tiktok only
                lists: [
                    {
                        value: 'amazon',
                        label: 'Amazon',
                        icon: <IconSocialAmazon />
                    },
                    {
                        value: 'bunnynet',
                        label: 'Bunnynet',
                        icon: <IconSocialBunnynet />
                    }
                ]
            },
            audio: {
                labelOnChangeOption: 'Upload your audio',
                type: 'audio',   // file attachment max 1, allowed file type: MP3
                rules: {
                    // allowedFileType: ['.mp3', '.wav', '.wma', '.aac', '.ogg'],
                    allowedFileType: ['.mp3', '.mp4', '.wav'],
                    maxFileSize: 1024 * 1024 * 1024,
                },
            },
            duration: {
                labelOnChangeOption: 'Add Audio Duration',
                type: 'duration',  // in minutes, need convert to second for slide.duration
                helpText: 'Recommended min 1 max 300',
                relatedRequired: ['amazon'], // on Duration control not yet use
            },
        }
    }

    type() {
        return 'AudioTemplate';
    }

    name() {
        return 'Audio';
    }
    iconType() {
        return 'audio';
    }
    canRearrange() {
        return true;
    }
    canRenameLabel() {
        return true;
    }
    imageTemplate() {
        return (
            <div>
                <img src={require('../assets/img/template-image-audio.jpg')} className='img-fluid' alt='template' />
            </div>
        );
    }
    textHighlight() {
        return (
            <div>
                <span className='font-weight-700 text-dark'>Audio </span>
                <span className='text-muted'>help your audience understand the lesson through the voice.</span>
            </div>
        );
    }
    getDuration() {
        return 120;
    }
    render(data, index, inEditor) {
        return (
            <AudioPreview data={data} index={index} inEditor={inEditor} structures={this.structures()} />
        )
    }

    actions(data, index) {
        return (
            <NextAction label='Next' icon={<IconArrowMedium />} />
        );
    }
}

export default AudioTemplate;
